export const FETCH_PORTABILITY_DATES = 'OVID/LINES/FETCH_PORTABILITY_DATES'
export const FETCH_PORTABILITY_DATES_SUCCESS = 'OVID/LINES/FETCH_PORTABILITY_DATES_SUCCESS'
export const FETCH_PORTABILITY_DATES_ERROR = 'OVID/LINES/FETCH_PORTABILITY_DATES_ERROR'
